import React from 'react';
import { css, useTheme } from '@emotion/react';
import { BirdiTheme, breakpoints } from '@birdi/theme';
import type { WidgetId } from '../tabs';

export interface AddWidgetProps {
  onOpenModal: () => void;
  isReorderMode?: boolean;
}

export const AddWidget: React.FC<AddWidgetProps> = ({
  onOpenModal,
  isReorderMode = false,
}) => {
  const theme = useTheme();

  return (
    <div
        css={css`
          display: flex;
          flex-direction: column;
          border-radius: 1em;
          box-shadow: 2px 2px 2px ${theme.mono30};
          background: ${theme.mono10};
          min-height: 320px;
          min-width: 0;
          max-width: 100%;
          @media (max-width: ${breakpoints.s}) {
            min-height: 220px;
          }
          @media (max-width: ${breakpoints.xs}) {
            min-height: 180px;
            width: 100%;
          }
        `}
      >
        <div
          css={css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: ${theme.midnight};
            font-weight: 700;
            background: ${theme.lightOcean};
            padding: 1em;
            border-top-left-radius: 1em;
            border-top-right-radius: 1em;
          `}
        >
          <span>Customize your dashboard</span>
        </div>
        <div
          css={css`
            flex: 1 1 auto;
            padding: 1em;
            color: ${theme.mono50};
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            min-height: 200px;
          `}
        >
          <button
            onClick={onOpenModal}
            type="button"
            disabled={isReorderMode}
            css={css`
              width: 60%;
              background: ${theme.mono0};
              border: 1px solid ${theme.mono30};
              border-radius: 8px;
              padding: 1em 2em;
              font-size: 1em;
              font-weight: 500;
              color: ${theme.mono60};
              cursor: pointer;
              transition: background 0.2s, border-color 0.2s;
              &:hover {
                background: ${theme.mono10};
                border-color: ${theme.mono40};
              }
              &:disabled {
                opacity: 0.5;
                cursor: not-allowed;
              }
            `}
          >
            Add widget
          </button>
        </div>
    </div>
  );
};

